var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramMiniApps = function SvgTelegramMiniApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram-mini-apps_svg__a)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#telegram-mini-apps_svg__b)",
    d: "M56 112c30.928 0 56-25.072 56-56S86.928 0 56 0 0 25.072 0 56s25.072 56 56 56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.79 54.94Q49.748 44.5 57.742 41.177c15.215-6.329 18.377-7.428 20.437-7.464.453-.008 1.467.104 2.123.637.554.45.707 1.057.78 1.483s.164 1.398.092 2.157c-.825 8.664-4.393 29.687-6.208 39.39-.768 4.106-2.28 5.483-3.744 5.617-3.182.293-5.598-2.102-8.68-4.122-4.821-3.161-7.545-5.13-12.226-8.213-5.41-3.565-1.903-5.524 1.18-8.726.807-.838 14.825-13.59 15.096-14.746.034-.144.066-.684-.254-.968-.32-.285-.794-.188-1.135-.11q-.725.165-23.11 15.274-3.28 2.252-5.941 2.195c-1.957-.042-5.72-1.106-8.517-2.015-3.431-1.116-6.158-1.705-5.92-3.6q.185-1.48 4.075-3.026",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "telegram-mini-apps_svg__b",
    x1: 5600,
    x2: 5600,
    y1: 0,
    y2: 11116.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "telegram-mini-apps_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h112v112H0z"
  })))));
};
export { SvgTelegramMiniApps as ReactComponent };